import { render, staticRenderFns } from "./PendingDocumentValidationErrorModal.vue?vue&type=template&id=74b14d10"
import script from "./PendingDocumentValidationErrorModal.vue?vue&type=script&lang=ts"
export * from "./PendingDocumentValidationErrorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports